module.exports = __webpack_public_path__ + "img/teacherBackgorund.aae8f574.png";